import React, { useEffect, useState } from "react";
import './OfficePage.css';
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { getLoading, createOfficeAsync, setOfficesLoading, deleteOfficeAsync, updateOfficeAsync } from "../../../features/redux/adminSlice";
import Confirm from "../../ui/Confirm/Confirm";
import SideSlider from "../../ui/SideSlider/SideSlider";
import { useForm } from 'react-forms-handler';
import validator from 'validator';
import { validatePresenceOf } from "../../../utils";

const globals = { offices: [] };

function OfficePage({ offices }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const [filteredOffices, setFilteredOffices] = useState(offices);
  const [openForm, setOpenForm] = useState(false);
  const { form, valid, value, id, name, lat, lon, capacity, used, picture, open_hours, close_hours, price } = useForm({
    id: [''],
    name: ['', validatePresenceOf],
    lat: ['', validatePresenceOf],
    lon: ['', validatePresenceOf],
    capacity: ['', validatePresenceOf],
    used: ['', validatePresenceOf],
    picture: [''],
    open_hours: [''],
    close_hours: [''],
    price: ['', validatePresenceOf],
  });

  const { searchField } = useForm({
    searchField: ['']
  });

  useEffect(() => {
    globals.offices = offices;
    setFilteredOffices(offices.filter(o => getSearchableText(o).toLowerCase().includes(searchField.value.toLowerCase())));
  }, [offices, searchField]);

  useEffect(() => {
    searchField.stateChange.subscribe((currentValue, prevValue) => {
      setFilteredOffices(offices.filter(o => getSearchableText(o).toLowerCase().includes(currentValue.toLowerCase())));
    });
  }, [searchField]);

  return (
    <div className="offices-dashboard-content">
      <div className="dashboard-header">
        <h1>Admin Dashboard Offices</h1>
        <input style={{ width: '20%' }} type="text" className="form-control" {...searchField.inputProps} placeholder="Search" />
        <button className="btn btn-primary" onClick={() => { setOpenForm(true) }}>Add Office</button>
      </div>
      <table className="table">
        <thead className="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Latitude</th>
            <th scope="col">Longitude</th>
            <th scope="col">Capacity</th>
            <th scope="col">Used</th>
            <th scope="col">Open Hours</th>
            <th scope="col">Close Hours</th>
            <th scope="col">Price (in $)</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredOffices.map((office, index) => {
            return (
              <tr key={`office-${index}`} className={`${office.deleted_at ? 'deleted' : ''}`}>
                <th scope="row">{index + 1}</th>
                <td>{office.name}</td>
                <td>{office.lat}</td>
                <td>{office.lon}</td>
                <td>{office.capacity}</td>
                <td>{office.used}</td>
                <td>{office.open_hours}</td>
                <td>{office.close_hours}</td>
                <td>{(office.price / 100).toFixed(2)}</td>
                <td>{moment(office.createdAt).format("MMM Do YY")}</td>
                {!office.deleted_at && <td>
                  <i className={`text-danger fa-solid fa-${isLoading.offices !== office.id ? 'trash' : 'circle-notch fa-spin'}`} onClick={() => {
                    Confirm.confirm('Are you sure you want to delete this office? This action cannot be undone').then(() => {
                      dispatch(setOfficesLoading(office.id));
                    }).catch((e) => { console.log(e); });
                  }}></i>
                  <i style={{ marginLeft: '4px', cursor: 'pointer' }} className={`text-primary fa-solid fa-edit`} onClick={() => {
                    form.clearAllFields();
                    id.value = office.id;
                    name.value = office.name;
                    lat.value = office.lat;
                    lon.value = office.lon;
                    capacity.value = office.capacity;
                    used.value = office.used;
                    picture.value = office.picture;
                    open_hours.value = office.open_hours;
                    close_hours.value = office.close_hours;
                    price.value = (office.price / 100).toFixed(2);
                    setOpenForm(true);
                  }}></i>
                </td>}
                {office.deleted_at && <td>
                  <i style={{ cursor: 'pointer' }} className={`text-success fa-solid fa-${isLoading.offices !== office.id ? 'trash-restore' : 'circle-notch fa-spin'}`} onClick={() => {
                    Confirm.confirm('Are you sure you want to restore this office?').then(() => {
                      dispatch(setOfficesLoading(office.id));
                    }).catch((e) => { console.log(e); });
                  }}></i>
                </td>}
              </tr>
            );
          })}
        </tbody>
      </table>
      <SideSlider open={openForm}>
        <i style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }} className={`text-primary fa-solid fa-rectangle-xmark`} onClick={() => {
          setOpenForm(false);
          form.clearAllFields();
        }}></i>
        <form style={{ textAlign: 'left' }}>
          <div className="form-group">
            <label>Name</label>
            <input type="text" {...name.inputProps} className="form-control" placeholder="Enter name" />
            {name.touched && !name.valid && <small className="form-text text-danger">Cannot be empty</small>}
          </div>
          <div className="form-group">
            <label>Latitude</label>
            <input type="text" {...lat.inputProps} className="form-control" placeholder="Enter latitude" />
            {lat.touched && !lat.valid && <small className="form-text text-danger">Must be a valid number</small>}
          </div>
          <div className="form-group">
            <label>Longitude</label>
            <input type="text" {...lon.inputProps} className="form-control" placeholder="Enter longitude" />
            {lon.touched && !lon.valid && <small className="form-text text-danger">Must be a valid number</small>}
          </div>
          <div className="form-group">
            <label>Capacity</label>
            <input type="text" {...capacity.inputProps} className="form-control" placeholder="Enter capacity" />
            {capacity.touched && !capacity.valid && <small className="form-text text-danger">Must be a valid integer</small>}
          </div>
          <div className="form-group">
            <label>Used</label>
            <input type="text" {...used.inputProps} className="form-control" placeholder="Enter used capacity" />
            {used.touched && !used.valid && <small className="form-text text-danger">Must be a valid integer</small>}
          </div>
          <div className="form-group">
            <label>Picture URL</label>
            <input type="text" {...picture.inputProps} className="form-control" placeholder="Enter picture URL" />
          </div>
          <div className="form-group">
            <label>Open Hours</label>
            <input type="text" {...open_hours.inputProps} className="form-control" placeholder="Enter open hours" />
          </div>
          <div className="form-group">
            <label>Close Hours</label>
            <input type="text" {...close_hours.inputProps} className="form-control" placeholder="Enter close hours" />
          </div>
          <div className="form-group">
            <label>Price (in $)</label>
            <input type="text" {...price.inputProps} className="form-control" placeholder="Enter price in dollars" />
            {price.touched && !price.valid && <small className="form-text text-danger">Must be a valid number</small>}
          </div>
          <button disabled={!valid || isLoading.offices} type="submit" className="btn btn-primary" onClick={(e) => {
            price.value = (price.value * 100).toFixed(0); // Convert price back to cents
            if (id.value) {
              dispatch(updateOfficeAsync(value));
            } else {
              dispatch(createOfficeAsync(value));
            }
            setOpenForm(false);
            form.clearAllFields();
            e.preventDefault();
          }}>Submit</button>
        </form>
      </SideSlider>
    </div>
  );
}

function getSearchableText(office) {
  return `${office.name}${moment(office.createdAt).format("MMM Do YY")}`;
}

export default OfficePage;
